export function nonEmpty(value: any): string | null | undefined {
    if (value && value.length === 0) {
        return 'Please select at least one item';
    }
}
